// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"index_logoWrapper__12jFx","auth":"index_auth__2fbfM","menu":"index_menu__28Awd","link":"index_link__4tEf1","active":"index_active__1Q7vS"};